export const LOCAL_STORAGE_KEYS = {
    COUPON_CONFETTI_SHOWN: "coupon_confetti_shown",
    TURBO_PAYMENT_EDUCATION_COMMS_SHOWN: "turbo_payment_education_comms_shown_v3",
    TURBO_PAYMENT_EDUCATION_COMMS_SHOWN_TIMESTAMP: "turbo_payment_education_comms_timestamp",
    TURBO_PAYMENT_EDUCATION_CHANGE_COMMS_SHOWN: "turbo_payment_education_change_comms_shown",
    COUPON_CARD_NEW_BADGE_IMPRESSION_COUNT: "coupon_card_new_badge_impression_count",
    LOCAL_STORAGE_BULLS_EYE_TG: "swiggy_plan_bulls_eye_tg_count_v3",
    TURBO_PAYMENT_OFFER_COMMS_SHOWN_COUNT: "turbo_payment_offer_comms_shown_count",
    FK_COINS_ELIGIBLE_CART_COMMS_IMPRESSION_COUNT: "fk_coins_eligible_cart_comms_impression_count",
    FK_COINS_ELIGIBLE_PAYMENT_COMMS_IMPRESSION_COUNT: "fk_coins_eligible_payment_comms_impression_count",
    DELIVERY_SPEED_POPUP_COUNT: "delivery_speed_popup_count",
    PREVIOUS_RESTAURANT_ID: "previous-restaurant-id",
    OVERLAY_VISIBILITY: "overlay-visibility-key",
    ECO_SAVER_TOAST_FREQUENCY_CAPPING_KEY: "eco-saver-toast-frequency-capping-key",
    FOOTER_COMMS_CLICK_FREQUENCY_CAPPING_KEY: "footer-comms-click-frequency-capping-key",
    FOOTER_COMMS_VIEW_FREQUENCY_CAPPING_KEY: "footer-comms-view-frequency-capping-key",
    CROSS_SELL_M2_SHAKE_FREQUENCY_CAPPING_KEY: "cross-sell-m2-shake-frequency-capping-key",
    TURBO_TOOLTIP_VIEW_FREQUENCY_CAPPING_KEY: "turbo-tooltip-view-frequency-capping-key",
    TOING_POPUP_FREQUENCY_CAPPING_KEY: "toing-popup-frequency-capping-key",
    CROSS_SELL_MAGIC_DEALS_OVERLAY_LOTTIE: "CROSS_SELL_MAGIC_DEALS_OVERLAY_LOTTIE",
    AMAZON_PAY_DELINKED_MESSAGE_FREQUENCY_CAPPING_KEY: "amazon-pay-delinked-message-frequency-capping-key",
};

export const SESSION_STORAGE_KEYS = {
    RX_SPECIAL_INSTRUCTIONS: "rx_special_instructions",
    THIRD_PARTY_UPI_INTENT_APPS_DETAILS: "third_party_upi_intent_apps_details",
    DELIVERY_SPEED_POPUP_SEEN: "delivery_speed_popup_seen",
    IS_GROUP_ORDER_FLOW: "is_group_order_flow",
    GROUP_CART_ID: "group_cart_id",
    WITH_COUPON: "with_coupon",
    WITH_REWARD: "with_reward",
    BILL_AMOUNT_SHOWN_ON_CART: "bill_amount_shown_on_cart",
    BILL_TO_COMPANY_SELECTED: "bill_to_company_selected",
    EXPENSE_CODE_DATA: "expense_code_data",
    SPLITPAY_METHOD: "splitpay_method",
    TURBO_PAY_FALLBACK_CONFIG: "turbo_pay_fallback_config",
};
